import {
  IntersectionObserverData,
  useIntersectionObserver,
} from "@tm/ui/hooks";
import React, { useCallback, useRef } from "react";
import { trackListingView } from "../trackingUtils";

/** Maps listing component ids → the "seen" event name fired on scroll into view. */
const COMPONENT_IMPRESSION_MAP: Record<string, string> = {
  COMPONENT_LISTING_PAGE_PLANS_HEADER: "plans_header_seen",
  COMPONENT_LISTING_PAGE_MYP_MWEB_TRIP_CARDS: "plan_cards_seen",
  COMPONENT_LISTING_PAGE_PWA_TRIP_CARDS: "plan_cards_seen",
  COMPONENT_LISTING_PAGE_TRIP_CARDS: "plan_cards_seen",
  COMPONENT_LISTING_PAGE_BANNER: "listing_banner_seen",
  COMPONENT_LISTING_PAGE_CAROUSEL_PERSUASION:
    "listing_carousel_persuasion_seen",
  COMPONENT_LISTING_PERSUASION: "listing_persuasion_seen",
  COMPONENT_LISTING_PAGE_FAQ: "listing_faq_seen",
  COMPONENT_LISTING_PAGE_MYCASH: "listing_mycash_seen",
};

interface ImpressionWrapProps {
  componentId: string;
  planType?: string;
  children: React.ReactNode;
}

export const ImpressionWrap = ({
  componentId,
  planType,
  children,
}: ImpressionWrapProps) => {
  const hasTracked = useRef(false);

  const handleIntersection = useCallback(
    (_data: IntersectionObserverData) => {
      const eventName = COMPONENT_IMPRESSION_MAP[componentId];
      if (!hasTracked.current && eventName) {
        trackListingView(eventName, planType);
      }
      hasTracked.current = true;
    },
    [componentId, planType]
  );

  const { ref } = useIntersectionObserver(handleIntersection, {
    threshold: 0.5,
    triggerOnLeaveViewport: true,
  });

  return <div ref={ref}>{children}</div>;
};
